module.exports = __webpack_public_path__ + "img/marketplace_UberEats.7cfbbc43.svg";